module.exports = __webpack_public_path__ + "ac.no2.0adbd64c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ac.no2.jpg
// module id = 0Zre
// module chunks = 0